exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-picker-section-wrapper .vc-chrome{position:absolute;top:50%;right:0;z-index:9;left:0;margin:0 auto;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);

// exports
